const FacebookSvg = ({
  height = 14,
  width = 14,
  viewBox = '0 0 14 14',
  fill = 'white',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  fill?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <g clipPath="url(#clip0_24458_18784)">
        <path
          d="M14 7.04297C14 3.17722 10.8657 0.0429688 7 0.0429688C3.13425 0.0429688 0 3.17722 0 7.04297C0 10.5371 2.55967 13.4328 5.90625 13.9578V9.06655H4.12883V7.04239H5.90625V5.50122C5.90625 3.74714 6.95158 2.77764 8.5505 2.77764C9.31583 2.77764 10.1173 2.91472 10.1173 2.91472V4.6373H9.23417C8.36442 4.6373 8.09317 5.17689 8.09317 5.73047V7.04297H10.0345L9.72417 9.06713H8.09317V13.9584C11.4403 13.4328 14 10.5366 14 7.04297Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_24458_18784">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FacebookSvg;
